import { Heading, Pane, Spinner, Text, majorScale } from 'evergreen-ui';
import React, { FC } from 'react';

import GarnerWordmark from 'jsx:../assets/images/garner-wordmark.svg';
import constants from 'app-constants';

// Environment-aware Garner Admin Portal URL (dev/stg/prod) supplied by constants/<env>.js.
const ADMIN_PORTAL_URL: string = constants.adminPortalUrl;

// Hold the loader on screen briefly so users can read where they are being sent before we navigate.
const REDIRECT_DELAY_MS = 5000;

/**
 * Full-screen loader shown once the legacy portal is decommissioned (see helpers/decommission.ts).
 * It renders a "redirecting" message and then sends the browser to the Garner Admin Portal after a
 * short, intentional delay so the message is readable.
 *
 * `location.replace` is used instead of `location.assign` so the legacy URL is not left in the
 * browser history — the back button won't return the user to this dead-end page.
 */
export const RedirectView: FC = () => {
  React.useEffect(() => {
    const timer = window.setTimeout(() => {
      window.location.replace(ADMIN_PORTAL_URL);
    }, REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <Pane minHeight="100vh" display="flex" flexDirection="column">
      <Pane is="header" height={majorScale(5)} background="#006b59" paddingX={10} display="flex" alignItems="center">
        <GarnerWordmark height={24} color="#FFFFFF" />
      </Pane>
      <Pane
        flex="1 0 auto"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={majorScale(2)}
        padding={majorScale(4)}
        textAlign="center"
      >
        <Spinner />
        <Heading size={600}>Redirecting you to the Garner Admin Portal…</Heading>
        <Text size={400} color="muted">
          If you are not redirected automatically, please go to <a href={ADMIN_PORTAL_URL}>the Garner Admin Portal</a>.
        </Text>
      </Pane>
    </Pane>
  );
};
